import { Button, Card } from "@/components/ui";

interface NotificationPromptProps {
  onEnable: () => void;
  onDismiss: () => void;
  loading?: boolean;
}

export function NotificationPrompt({ onEnable, onDismiss, loading }: NotificationPromptProps) {
  return (
    <Card tone="accent">
      <div className="flex flex-col gap-3">
        <span className="text-text text-[0.9375rem] font-bold">
          <span role="img" aria-label="Notifications">
            {"\u{1F514}"}
          </span>{" "}
          Stay in the loop
        </span>
        <span className="text-text-muted text-[0.8125rem]">
          Enable push notifications to get step goal alerts and competition updates.
        </span>
        <div className="flex gap-2">
          <Button label={loading ? "Enabling..." : "Enable"} onPress={onEnable} />
          <Button label="Not now" kind="ghost" onPress={onDismiss} />
        </div>
      </div>
    </Card>
  );
}
